<template>
   <svg width="27" height="21" viewBox="0 0 27 21" xmlns="http://www.w3.org/2000/svg">
     <path d="M21.91 15.09a.97.97 0 110-1.95.97.97 0 010 1.95M18.02 18a.97.97 0 110-1.94.97.97 0 010 1.94m-3.88-2.91a.97.97 0 110-1.95.97.97 0 010 1.95m-3.9-4.86a.97.97 0 110-1.95.97.97 0 010 1.95m-2.9 2.91a.97.97 0 110-1.94.97.97 0 010 1.94m-3.9-3.89a.97.97 0 110-1.94.97.97 0 010 1.94m20.38-2.94a8.67 8.67 0 00-3.05-1.87c-1.28-.46-2.27-1.27-3.42-1.98a9.47 9.47 0 00-3.86-1.33c-.84-.1-1.7-.05-2.53-.18C10.12.8 9.38.4 8.57.18a8.95 8.95 0 00-4.87.4C1.5 1.4-.14 4.68 0 6.92c.08 1.2.41 2.39.74 3.55.47 1.63 1.71 2.24 3.1 2.94.49.25 1.01.39 1.49.64 1.06.58 1.73 1.67 2.65 2.44.44.36.94.66 1.46.9.79.37 1.64.47 2.38.91.84.5 1.59 1.14 2.41 1.65 1.23.78 2.33.96 3.74.78 1.5-.2 2.94-.36 4.32-1.04a7.77 7.77 0 004.25-7.37 8.87 8.87 0 00-2.73-6"/>
   </svg>
</template>

<script>
export default {
   name: 'PotatoIcon'
}
</script>